const paths={
 before:'<path d="m15 18-6-6 6-6"/>',after:'<path d="m9 18 6-6-6-6"/>',
 first:'<path d="M5 5v14M19 18l-6-6 6-6"/>',last:'<path d="M19 5v14M5 6l6 6-6 6"/>',
 reset:'<path d="M3 10a9 9 0 1 1 2.6 8.4M3 4v6h6"/>',
 flip:'<path d="m16 3 4 4-4 4M20 7H5M8 21l-4-4 4-4M4 17h15"/>',
 analysis:'<path d="M4 4v16h16M8 14l4-4 4 3 4-7"/>'
};
export function chessControlIcon(name){return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'+paths[name]+'</svg>';}
export function setChessControlIcon(button,name,label){button.innerHTML=chessControlIcon(name);button.classList.add('chess-icon-control');button.setAttribute('aria-label',label);button.title=label;}
